<template>
  <v-list-subheader><slot /></v-list-subheader>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/*
 * Thin wrapper over Vuetify's list subheader so the Vuetify 2 -> 3 rename
 * (v-subheader -> v-list-subheader) is a single-file change instead of touching
 * every call site (5 files / 8 usages). `class`/`style` and the default slot
 * forward to the single root element automatically (default inheritAttrs).
 * Migrated to <v-list-subheader> for Vuetify 3 (V2's <v-subheader> no longer exists).
 */
export default defineComponent({
  name: 'AppSubheader',
})
</script>
